import React, { useEffect, useState } from "react";
import { FaUserCircle } from "react-icons/fa";
import useAxios from "../api/useAxios";

const Profile = () => {
  const axios = useAxios();

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        setLoading(true);
        const res = await axios.get("/auth/profile");

        if (res.data.success) {
          setUser(res.data.data);
        } else {
          setError(res.data.message || "Failed to fetch profile");
        }
      } catch (err) {
        setError(
          err.response?.data?.message || "Something went wrong while loading profile"
        );
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-blue-50">
        <p className="text-slate-500">Loading profile...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-blue-50">
        <p className="text-red-500">{error}</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-blue-50 flex items-center justify-center p-6">
      <div className="bg-white w-full max-w-lg rounded-2xl shadow-md p-6">

        {/* HEADER */}
        <div className="flex flex-col items-center mb-6">
          <FaUserCircle className="text-6xl text-blue-500 mb-2" />
          <h2 className="text-xl font-semibold">{user.fullName}</h2>
          <p className="text-sm text-slate-500">{user.role}</p>
        </div>

        {/* DETAILS */}
        <div className="space-y-4 text-sm">
          <div className="flex justify-between">
            <span className="text-slate-500">Name</span>
            <span className="font-medium">{user.fullName}</span>
          </div>

          <div className="flex justify-between">
            <span className="text-slate-500">Email</span>
            <span className="font-medium">{user.email}</span>
          </div>

          <div className="flex justify-between">
            <span className="text-slate-500">Mobile No</span>
            <span className="font-medium">{user.mobileNumber}</span>
          </div>

          <div className="flex justify-between">
            <span className="text-slate-500">Role</span>
            <span className="font-medium">{user.role}</span>
          </div>

          {user.businessName && (
            <div className="flex justify-between">
              <span className="text-slate-500">Business</span>
              <span className="font-medium">{user.businessName}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Profile;
